export const dealShowFr = {
  demo: {
    title: "Démo",
    none: "Aucune démo planifiée.",
    schedule: "Planifier une démo",
    join: "Rejoindre la démo Teams",
    edit: "Modifier la démo",
    cancel: "Annuler la démo",
    cancel_title: "Annuler la démo ?",
    cancel_body: "La date et le lien Teams seront retirés du deal.",
    confirm: "Confirmer",
    cancelled: "Démo annulée.",
    cancel_failed: "Impossible d'annuler la démo.",
    held: "Démo tenue",
  },
  emails: {
    title: "Courriels",
    empty: "Aucun courriel pour ce deal.",
    error: "Courriels indisponibles.",
  },
  history: {
    title: "Historique des étapes",
    created: "Création",
    empty: "Aucun changement d'étape.",
    error: "Historique indisponible.",
  },
  outcome: {
    won_on: "Gagné le %{date}",
    lost_because: "Perdu : %{reason}",
  },
  source: "Source",
  retry: "Réessayer",
};
